export default __webpack_public_path__ + "static/promontory-logo-white-3b5021e2e550e769a093378ef2c25a1e.svg";